// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mPre {
  white-space: pre;
}

.mVerticalAlignMiddle td {
  vertical-align: middle;
}

.mMarginRight {
  margin-right: 10px;
}

.mLineHeight {
  line-height: 38px;
  height: 38px;
}

.mTextAlignLeft {
  text-align: left;
}

/*not a good solution but an easy way to press table columns to left, like amazon table*/
.mPressToLeft td:last-child {
  width: 100%;
}

.mMinWidth100 thead th {
  min-width: 100px;
}

.mMinWidth100 thead th:first-child {
  min-width: auto;
}
.staff-chipCell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  white-space: normal;
}

.staff-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 11.5px;
  line-height: 1;
  font-weight: 700;
}

.staff-chip--role {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.staff-chip--sport {
  background: var(--slate-100, #f1f5f9);
  color: var(--text-body, #334155);
  font-weight: 650;
}

.staff-chipMore {
  color: var(--text-subtle, #94a3b8);
  font-size: 11.5px;
  font-weight: 700;
}

.staff-chipEmpty {
  color: var(--text-subtle, #94a3b8);
}
.staffsPage {
  color: var(--text-body, #334155);
}

.staffsPage .table-responsive {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
  overflow: auto;
}

.staffsPage .table {
  margin: 0 !important;
  font-size: 13px;
  color: var(--text-body, #334155);
}

.staffsPage .table thead th {
  border-top: 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.staffsPage .table tbody td {
  border-top: 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  vertical-align: middle !important;
}

.staffsPage .table-hover tbody tr:hover {
  background: var(--slate-50, #f8fafc);
}

.staffsPage .table-primary,
.staffsPage .table-primary > td {
  background: var(--blue-50, #eef6fc) !important;
}

.staffsPage .btn {
  border-radius: var(--radius-md, 8px) !important;
  font-size: 13px;
  font-weight: 650;
  box-shadow: none !important;
}

.staffsPage .custom-checkbox input[type='checkbox'] {
  width: 16px;
  height: 16px;
  accent-color: var(--blue-500, #227ebd);
}

.staff-modernScreen .people-toolbar__heading {
  align-items: flex-end;
}

.staff-modernTable {
  min-width: 1040px;
}

.staff-avatar--image {
  background-size: cover;
  background-position: center;
  color: transparent;
}

.staff-modernChips {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.staff-modernChip {
  min-height: 21px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  color: var(--text-body, #334155);
  background: var(--slate-100, #f1f5f9);
  font-size: 11px;
  font-weight: 750;
}

.staff-modernChip--role {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.staff-modernChip--sport {
  background: var(--green-50, #edf8f1);
  color: var(--green-700, #17643a);
}

.staff-modernChipMore {
  display: inline-flex;
  align-items: center;
  min-height: 21px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 750;
}

.staff-drawerFoot {
  flex-wrap: wrap;
}

.staff-drawerFoot .people-btn {
  flex: 1 1 calc(50% - 8px);
}

@media (max-width: 620px) {
  .staff-drawerFoot .people-btn {
    flex-basis: 100%;
  }
}

.staff-accessEditor {
  display: flex;
  flex-direction: column;
  gap: 0;
  color: var(--text-body, #334155);
}

.staff-accessSection {
  padding: 16px 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.staff-accessSection:first-child {
  padding-top: 0;
}

.staff-accessSection__head {
  min-height: 30px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.staff-accessSection__head > span,
.staff-accessLabel {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.staff-roleCards {
  display: grid;
  gap: 10px;
}

.staff-roleCard {
  padding: 12px 13px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--slate-25, #fbfdff);
}

.staff-roleCard__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.staff-roleCard__meta {
  margin-top: 9px;
}

.staff-roleStatus {
  min-height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.staff-roleStatus--active {
  background: #e8f7ee;
  color: #268049;
}

.staffsPage .peopleDangerModal.modal-dialog {
  max-width: 520px;
}

.staffsPage .people-roleRevoke {
  gap: 12px;
}

.staffsPage .people-delete__alert--noIcon {
  grid-template-columns: minmax(0, 1fr);
  padding: 12px 14px;
}

.staffsPage .people-roleRevoke .people-delete__details {
  gap: 6px;
}

.staffsPage .people-roleRevoke .people-delete__names {
  max-height: 72px;
  padding: 8px 10px;
}

.staffsPage .peopleDangerModal__content {
  display: grid;
  gap: 16px;
}

.staffsPage .peopleDangerModal__icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff1f3;
  color: #b4233b;
  font-size: 24px;
  font-weight: 800;
}

.staffsPage .peopleDangerModal__copy strong,
.staffsPage .peopleDangerModal__warning strong {
  color: #101828;
  font-size: 14px;
}

.staffsPage .peopleDangerModal__copy p,
.staffsPage .peopleDangerModal__warning p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}

.staffsPage .peopleDangerModal__warning {
  padding: 12px 14px;
  border: 1px solid #fecdd3;
  border-radius: 10px;
  background: #fff7f8;
}

.staffsPage .peopleDangerModal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.staff-roleCard__sports {
  margin-top: 11px;
}

.staff-accessChips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.staff-accessChip {
  min-height: 26px;
  padding: 0 5px 0 10px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: color-mix(in srgb, var(--staff-chip-color, #227ebd) 13%, #ffffff);
  color: var(--staff-chip-color, #227ebd);
  font-size: 12px;
  font-weight: 750;
}

.staff-accessChip i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--staff-chip-color, #227ebd);
}

.staff-accessChip button {
  width: 18px;
  height: 18px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
}

.staff-accessChip button:hover {
  background: rgba(15, 23, 42, 0.08);
}

.staff-accessAddSelect {
  min-height: 28px;
  max-width: 180px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #ffffff);
  color: var(--text-muted, #64748b);
  padding: 0 9px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.staff-inlineMulti {
  position: relative;
  display: flex;
  flex: 0 0 100%;
  width: 100%;
  min-width: 0;
  align-items: flex-start;
}

.staff-accessAddButton {
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: #fff;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.staff-accessAddButton:hover {
  border-color: var(--border-brand, #6fb1df);
  color: var(--brand-primary, #227ebd);
}

.staff-inlineMulti__popover {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 20;
  width: min(300px, 100%);
  max-width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.18);
}

.staff-inlineMulti__popover,
.staff-inlineMulti__popover * {
  box-sizing: border-box;
}

.staff-inlineMulti__popover > input {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 7px;
  color: #334155;
  font-size: 13px;
}

.staff-inlineMulti__options {
  max-height: 230px;
  margin-top: 8px;
  overflow-y: auto;
}

.staff-inlineMulti__options label {
  min-height: 36px;
  margin: 0;
  padding: 7px 8px;
  display: flex;
  align-items: center;
  gap: 9px;
  border-radius: 7px;
  color: #334155;
  font-size: 13px;
  cursor: pointer;
}

.staff-inlineMulti__options label:hover {
  background: #f1f6fa;
}

.staff-inlineMulti__options input {
  width: 16px;
  height: 16px;
  accent-color: var(--brand-primary, #227ebd);
}

.staff-inlineMulti__empty {
  padding: 12px 8px;
  display: block;
  color: #94a3b8;
  font-size: 12px;
}

.staff-inlineMulti__actions {
  margin-top: 9px;
  padding-top: 9px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.staff-inlineMulti__actions .sit-btn {
  min-height: 32px;
  padding: 0 11px;
}

.staff-accessAddSelect:focus {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.staff-accessEmpty {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
  font-weight: 600;
}
.staff-filter {
  grid-template-columns: repeat(4, minmax(140px, 1fr)) auto;
  align-items: end;
  column-gap: 16px;
  padding: 16px;
  border-color: var(--border-subtle, #dbe3ec);
  background: var(--surface-subtle, #f8fafc);
  box-shadow: none;
}

.staff-filter .people-filter__field {
  gap: 7px;
}

.staff-filter .people-filter__field > span {
  color: var(--text-body, #334155);
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.staff-filter .staff-filter__select {
  width: 100%;
  height: 38px;
  padding: 0 36px 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  appearance: none;
  background-color: var(--surface-card, #fff);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 11px center;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 13px;
  line-height: 1;
  font-weight: 650;
  cursor: pointer;
  transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;
}

.staff-filter .staff-filter__select--placeholder {
  color: var(--text-muted, #64748b);
  font-weight: 550;
}

.staff-filter .staff-filter__select:hover {
  border-color: var(--border-strong, #94a3b8);
}

.staff-filter .staff-filter__select:focus {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));
}

.staff-filter .staff-filter__select option {
  background: #fff;
  color: var(--text-strong, #0f172a);
  font-weight: 500;
}

.staff-filter .people-filter__actions {
  align-self: end;
  min-height: 38px;
  transform: translateY(-9px);
}

.staff-filter .people-filter__actions .people-btn {
  height: 38px;
  min-height: 38px;
}

@media (max-width: 920px) {
  .staff-filter {
    grid-template-columns: repeat(2, minmax(150px, 1fr));
  }
}
.staff-modernScreen .people-toolbar__heading {
  align-items: center;
}

.staffsPage {
  width: 100%;
  margin-top: 0 !important;
}

.unionAdminsPageHeader {
  display: flex;
  width: calc(100% + 48px);
  height: 70px;
  align-items: center;
  margin: -20px 0 18px -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.unionAdminsPageHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.015em;
  white-space: nowrap;
}
.unionAdminsPageHeader > span {
  display: inline-flex;
  min-width: 24px;
  height: 22px;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11.5px;
  font-weight: 800;
}

.unionAdminsListCard {
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
}

.unionAdminsListCard .people-toolbar {
  margin: 0;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px 12px 0 0;
  background: var(--surface-card, #fff);
}

.unionAdminsListCard .people-toolbar__heading {
  min-height: 38px;
  gap: 8px;
  padding: 0;
}
.unionAdminsSearch {
  display: inline-flex;
  width: min(340px, 100%);
  margin: 0;
}
.unionAdminsSearch input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-strong, #0f172a);
  font-size: 13px;
}
.unionAdminsSearch input:focus {
  border-color: var(--blue-500, #227ebd);
  outline: 0;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.13);
}

.unionAdminsListCard .people-toolbar .people-btn {
  height: 32px;
  min-height: 32px;
  border-radius: 7px;
  font-size: 13px;
}

.unionAdminsListCard .staff-toolbarSearch {
  margin-top: 10px;
}

.unionAdminsListCard .staff-toolbarSearch input {
  height: 38px;
  font-size: 13px;
}

.unionAdminsListCard .people-filter,
.unionAdminsListCard .people-filterChips,
.unionAdminsListCard .people-selection {
  margin: 0;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.unionAdminsFilterScrim {
  position: fixed;
  z-index: 1049;
  inset: 0;
  background: rgba(15, 23, 42, 0.22);
}

.unionAdminsListCard .staff-filter {
  z-index: 1050;
  padding: 0;
  gap: 0;
  border-left: 1px solid var(--border-subtle, #e2e8f0);
  background: #fff;
}
.unionAdminsListCard .staff-filter .people-filter__header {
  flex: 0 0 64px;
  padding: 0 20px;
}
.unionAdminsFilterFields {
  display: flex;
  padding: 20px;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 16px;
}
.unionAdminsFilterFields label {
  display: flex;
  margin: 0;
  flex-direction: column;
  gap: 6px;
}
.unionAdminsFilterFields label > span {
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}
.unionAdminsFilterFields input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-strong, #0f172a);
  font-size: 13px;
}
.unionAdminsListCard .staff-filter .unionAdminsFilterActions {
  display: flex;
  min-height: 64px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 12px 20px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  transform: none;
}
.unionAdminsFilterActions > div {
  display: flex;
  gap: 8px;
}

.unionAdminsListCard .people-tableCard {
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.unionAdminsListCard .people-pagination {
  margin: 0;
  padding: 12px 16px 14px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 0 0 12px 12px;
  background: var(--surface-card, #fff);
}

@media (max-width: 1217px) {
  .unionAdminsPageHeader {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}
.staff-modernScreen .staff-toolbarSearch {
  width: 100%;
  margin-top: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  transform: none;
}
@media (max-width: 1100px) {
  .staff-modernScreen .staff-toolbarSearch {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 620px) {
  .staff-modernScreen .staff-toolbarSearch {
    grid-template-columns: 1fr;
  }
}
.staffRoleModal.modal-dialog {
  max-width: 560px !important;
}
.staffRoleModal .modal-content {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  overflow: hidden;
}
.staffRoleModal .modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: #fff;
}
.staffRoleModal .modal-title {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));
  font-size: 18px;
  font-weight: 800;
}
.staffRoleModal .modal-body {
  padding: 18px 20px 20px !important;
}
.staffRoleModal form {
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.staffRoleModal form .form-control {
  min-height: 40px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  box-shadow: none;
}
.staffRoleModal form .form-control:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}
.staffRoleModal form label {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}
.staffRoleModal form .btn {
  min-height: 40px;
  padding: 0 15px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  text-transform: none;
}
.staffRoleModal form .btn-primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}
.staffRoleModal form .btn-secondary {
  border-color: var(--border-default, #cbd5e1);
  background: #fff;
  color: var(--text-strong, #0f172a);
}
.staffsPage > .modal:not(.userTagActionModal) .modal-dialog {
  max-width: 560px;
}
.staffsPage > .modal:not(.userTagActionModal) .modal-content {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  overflow: hidden;
}
.staffsPage > .modal:not(.userTagActionModal) .modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: #fff;
}
.staffsPage > .modal:not(.userTagActionModal) .modal-title {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));
  font-size: 18px;
  font-weight: 800;
}
.staffsPage > .modal:not(.userTagActionModal) .modal-body {
  padding: 18px 20px !important;
  color: var(--text-body, #334155);
}
.staffsPage > .modal:not(.userTagActionModal) .modal-footer {
  padding: 14px 20px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
}
.staffsPage > .modal:not(.userTagActionModal) .modal-footer .btn {
  min-height: 40px;
  padding: 0 15px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  text-transform: none;
}
.staffsPage > .modal:not(.userTagActionModal) .modal-footer .btn-primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}
.staffsPage > .modal:not(.userTagActionModal) .modal-footer .btn-secondary {
  border-color: var(--border-default, #cbd5e1);
  background: #fff;
  color: var(--text-strong, #0f172a);
}
.staffsPage > .modal:not(.userTagActionModal) .form-control {
  min-height: 40px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  box-shadow: none;
}
.staffsPage > .modal:not(.userTagActionModal) .form-control:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Users/Staffs/Staffs.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wFAAwF;AACxF;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;EAC9D,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,oCAAoC;EACpC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6EAA6E;EAC7E,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,oCAAoC;EACpC,wCAAwC;EACxC,iCAAiC;EACjC,cAAc;EACd,mEAAmE;EACnE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yDAAyD;EACzD,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gDAAgD;EAChD,oCAAoC;EACpC,gBAAgB;EAChB,2CAA2C;EAC3C,wQAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,mEAAmE;EACnE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sDAAsD;EACtD,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;;EAGE,SAAS;EACT,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,MAAM;EACN,oDAAoD;EACpD,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mDAAmD;EACnD,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;AACjB;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,8FAA8F;EAC9F,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,mEAAmE;AACrE;AACA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,8FAA8F;EAC9F,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE","sourcesContent":[".mPre {\n  white-space: pre;\n}\n\n.mVerticalAlignMiddle td {\n  vertical-align: middle;\n}\n\n.mMarginRight {\n  margin-right: 10px;\n}\n\n.mLineHeight {\n  line-height: 38px;\n  height: 38px;\n}\n\n.mTextAlignLeft {\n  text-align: left;\n}\n\n/*not a good solution but an easy way to press table columns to left, like amazon table*/\n.mPressToLeft td:last-child {\n  width: 100%;\n}\n\n.mMinWidth100 thead th {\n  min-width: 100px;\n}\n\n.mMinWidth100 thead th:first-child {\n  min-width: auto;\n}\n.staff-chipCell {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  white-space: normal;\n}\n\n.staff-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 9px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  line-height: 1;\n  font-weight: 700;\n}\n\n.staff-chip--role {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.staff-chip--sport {\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-weight: 650;\n}\n\n.staff-chipMore {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n.staff-chipEmpty {\n  color: var(--text-subtle, #94a3b8);\n}\n.staffsPage {\n  color: var(--text-body, #334155);\n}\n\n.staffsPage .table-responsive {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n  overflow: auto;\n}\n\n.staffsPage .table {\n  margin: 0 !important;\n  font-size: 13px;\n  color: var(--text-body, #334155);\n}\n\n.staffsPage .table thead th {\n  border-top: 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.staffsPage .table tbody td {\n  border-top: 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  vertical-align: middle !important;\n}\n\n.staffsPage .table-hover tbody tr:hover {\n  background: var(--slate-50, #f8fafc);\n}\n\n.staffsPage .table-primary,\n.staffsPage .table-primary > td {\n  background: var(--blue-50, #eef6fc) !important;\n}\n\n.staffsPage .btn {\n  border-radius: var(--radius-md, 8px) !important;\n  font-size: 13px;\n  font-weight: 650;\n  box-shadow: none !important;\n}\n\n.staffsPage .custom-checkbox input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--blue-500, #227ebd);\n}\n\n.staff-modernScreen .people-toolbar__heading {\n  align-items: flex-end;\n}\n\n.staff-modernTable {\n  min-width: 1040px;\n}\n\n.staff-avatar--image {\n  background-size: cover;\n  background-position: center;\n  color: transparent;\n}\n\n.staff-modernChips {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n\n.staff-modernChip {\n  min-height: 21px;\n  padding: 0 8px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-body, #334155);\n  background: var(--slate-100, #f1f5f9);\n  font-size: 11px;\n  font-weight: 750;\n}\n\n.staff-modernChip--role {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.staff-modernChip--sport {\n  background: var(--green-50, #edf8f1);\n  color: var(--green-700, #17643a);\n}\n\n.staff-modernChipMore {\n  display: inline-flex;\n  align-items: center;\n  min-height: 21px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 750;\n}\n\n.staff-drawerFoot {\n  flex-wrap: wrap;\n}\n\n.staff-drawerFoot .people-btn {\n  flex: 1 1 calc(50% - 8px);\n}\n\n@media (max-width: 620px) {\n  .staff-drawerFoot .people-btn {\n    flex-basis: 100%;\n  }\n}\n\n.staff-accessEditor {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  color: var(--text-body, #334155);\n}\n\n.staff-accessSection {\n  padding: 16px 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.staff-accessSection:first-child {\n  padding-top: 0;\n}\n\n.staff-accessSection__head {\n  min-height: 30px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.staff-accessSection__head > span,\n.staff-accessLabel {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.staff-roleCards {\n  display: grid;\n  gap: 10px;\n}\n\n.staff-roleCard {\n  padding: 12px 13px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--slate-25, #fbfdff);\n}\n\n.staff-roleCard__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.staff-roleCard__meta {\n  margin-top: 9px;\n}\n\n.staff-roleStatus {\n  min-height: 22px;\n  padding: 0 8px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.staff-roleStatus--active {\n  background: #e8f7ee;\n  color: #268049;\n}\n\n.staffsPage .peopleDangerModal.modal-dialog {\n  max-width: 520px;\n}\n\n.staffsPage .people-roleRevoke {\n  gap: 12px;\n}\n\n.staffsPage .people-delete__alert--noIcon {\n  grid-template-columns: minmax(0, 1fr);\n  padding: 12px 14px;\n}\n\n.staffsPage .people-roleRevoke .people-delete__details {\n  gap: 6px;\n}\n\n.staffsPage .people-roleRevoke .people-delete__names {\n  max-height: 72px;\n  padding: 8px 10px;\n}\n\n.staffsPage .peopleDangerModal__content {\n  display: grid;\n  gap: 16px;\n}\n\n.staffsPage .peopleDangerModal__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff1f3;\n  color: #b4233b;\n  font-size: 24px;\n  font-weight: 800;\n}\n\n.staffsPage .peopleDangerModal__copy strong,\n.staffsPage .peopleDangerModal__warning strong {\n  color: #101828;\n  font-size: 14px;\n}\n\n.staffsPage .peopleDangerModal__copy p,\n.staffsPage .peopleDangerModal__warning p {\n  margin: 5px 0 0;\n  color: #667085;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.staffsPage .peopleDangerModal__warning {\n  padding: 12px 14px;\n  border: 1px solid #fecdd3;\n  border-radius: 10px;\n  background: #fff7f8;\n}\n\n.staffsPage .peopleDangerModal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.staff-roleCard__sports {\n  margin-top: 11px;\n}\n\n.staff-accessChips {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.staff-accessChip {\n  min-height: 26px;\n  padding: 0 5px 0 10px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: color-mix(in srgb, var(--staff-chip-color, #227ebd) 13%, #ffffff);\n  color: var(--staff-chip-color, #227ebd);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.staff-accessChip i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--staff-chip-color, #227ebd);\n}\n\n.staff-accessChip button {\n  width: 18px;\n  height: 18px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1;\n}\n\n.staff-accessChip button:hover {\n  background: rgba(15, 23, 42, 0.08);\n}\n\n.staff-accessAddSelect {\n  min-height: 28px;\n  max-width: 180px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #ffffff);\n  color: var(--text-muted, #64748b);\n  padding: 0 9px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.staff-inlineMulti {\n  position: relative;\n  display: flex;\n  flex: 0 0 100%;\n  width: 100%;\n  min-width: 0;\n  align-items: flex-start;\n}\n\n.staff-accessAddButton {\n  min-height: 28px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: #fff;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.staff-accessAddButton:hover {\n  border-color: var(--border-brand, #6fb1df);\n  color: var(--brand-primary, #227ebd);\n}\n\n.staff-inlineMulti__popover {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 20;\n  width: min(300px, 100%);\n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.18);\n}\n\n.staff-inlineMulti__popover,\n.staff-inlineMulti__popover * {\n  box-sizing: border-box;\n}\n\n.staff-inlineMulti__popover > input {\n  width: 100%;\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 7px;\n  color: #334155;\n  font-size: 13px;\n}\n\n.staff-inlineMulti__options {\n  max-height: 230px;\n  margin-top: 8px;\n  overflow-y: auto;\n}\n\n.staff-inlineMulti__options label {\n  min-height: 36px;\n  margin: 0;\n  padding: 7px 8px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  border-radius: 7px;\n  color: #334155;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.staff-inlineMulti__options label:hover {\n  background: #f1f6fa;\n}\n\n.staff-inlineMulti__options input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--brand-primary, #227ebd);\n}\n\n.staff-inlineMulti__empty {\n  padding: 12px 8px;\n  display: block;\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.staff-inlineMulti__actions {\n  margin-top: 9px;\n  padding-top: 9px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.staff-inlineMulti__actions .sit-btn {\n  min-height: 32px;\n  padding: 0 11px;\n}\n\n.staff-accessAddSelect:focus {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.staff-accessEmpty {\n  min-height: 24px;\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n  font-weight: 600;\n}\n.staff-filter {\n  grid-template-columns: repeat(4, minmax(140px, 1fr)) auto;\n  align-items: end;\n  column-gap: 16px;\n  padding: 16px;\n  border-color: var(--border-subtle, #dbe3ec);\n  background: var(--surface-subtle, #f8fafc);\n  box-shadow: none;\n}\n\n.staff-filter .people-filter__field {\n  gap: 7px;\n}\n\n.staff-filter .people-filter__field > span {\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.staff-filter .staff-filter__select {\n  width: 100%;\n  height: 38px;\n  padding: 0 36px 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  appearance: none;\n  background-color: var(--surface-card, #fff);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 11px center;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 13px;\n  line-height: 1;\n  font-weight: 650;\n  cursor: pointer;\n  transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;\n}\n\n.staff-filter .staff-filter__select--placeholder {\n  color: var(--text-muted, #64748b);\n  font-weight: 550;\n}\n\n.staff-filter .staff-filter__select:hover {\n  border-color: var(--border-strong, #94a3b8);\n}\n\n.staff-filter .staff-filter__select:focus {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));\n}\n\n.staff-filter .staff-filter__select option {\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n  font-weight: 500;\n}\n\n.staff-filter .people-filter__actions {\n  align-self: end;\n  min-height: 38px;\n  transform: translateY(-9px);\n}\n\n.staff-filter .people-filter__actions .people-btn {\n  height: 38px;\n  min-height: 38px;\n}\n\n@media (max-width: 920px) {\n  .staff-filter {\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\n  }\n}\n.staff-modernScreen .people-toolbar__heading {\n  align-items: center;\n}\n\n.staffsPage {\n  width: 100%;\n  margin-top: 0 !important;\n}\n\n.unionAdminsPageHeader {\n  display: flex;\n  width: calc(100% + 48px);\n  height: 70px;\n  align-items: center;\n  margin: -20px 0 18px -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.unionAdminsPageHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -0.015em;\n  white-space: nowrap;\n}\n.unionAdminsPageHeader > span {\n  display: inline-flex;\n  min-width: 24px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  margin-left: 10px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11.5px;\n  font-weight: 800;\n}\n\n.unionAdminsListCard {\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n}\n\n.unionAdminsListCard .people-toolbar {\n  margin: 0;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px 12px 0 0;\n  background: var(--surface-card, #fff);\n}\n\n.unionAdminsListCard .people-toolbar__heading {\n  min-height: 38px;\n  gap: 8px;\n  padding: 0;\n}\n.unionAdminsSearch {\n  display: inline-flex;\n  width: min(340px, 100%);\n  margin: 0;\n}\n.unionAdminsSearch input {\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n}\n.unionAdminsSearch input:focus {\n  border-color: var(--blue-500, #227ebd);\n  outline: 0;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.13);\n}\n\n.unionAdminsListCard .people-toolbar .people-btn {\n  height: 32px;\n  min-height: 32px;\n  border-radius: 7px;\n  font-size: 13px;\n}\n\n.unionAdminsListCard .staff-toolbarSearch {\n  margin-top: 10px;\n}\n\n.unionAdminsListCard .staff-toolbarSearch input {\n  height: 38px;\n  font-size: 13px;\n}\n\n.unionAdminsListCard .people-filter,\n.unionAdminsListCard .people-filterChips,\n.unionAdminsListCard .people-selection {\n  margin: 0;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.unionAdminsFilterScrim {\n  position: fixed;\n  z-index: 1049;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.22);\n}\n\n.unionAdminsListCard .staff-filter {\n  z-index: 1050;\n  padding: 0;\n  gap: 0;\n  border-left: 1px solid var(--border-subtle, #e2e8f0);\n  background: #fff;\n}\n.unionAdminsListCard .staff-filter .people-filter__header {\n  flex: 0 0 64px;\n  padding: 0 20px;\n}\n.unionAdminsFilterFields {\n  display: flex;\n  padding: 20px;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 16px;\n}\n.unionAdminsFilterFields label {\n  display: flex;\n  margin: 0;\n  flex-direction: column;\n  gap: 6px;\n}\n.unionAdminsFilterFields label > span {\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n.unionAdminsFilterFields input {\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n}\n.unionAdminsListCard .staff-filter .unionAdminsFilterActions {\n  display: flex;\n  min-height: 64px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  padding: 12px 20px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  transform: none;\n}\n.unionAdminsFilterActions > div {\n  display: flex;\n  gap: 8px;\n}\n\n.unionAdminsListCard .people-tableCard {\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.unionAdminsListCard .people-pagination {\n  margin: 0;\n  padding: 12px 16px 14px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 0 0 12px 12px;\n  background: var(--surface-card, #fff);\n}\n\n@media (max-width: 1217px) {\n  .unionAdminsPageHeader {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n.staff-modernScreen .staff-toolbarSearch {\n  width: 100%;\n  margin-top: 10px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  transform: none;\n}\n@media (max-width: 1100px) {\n  .staff-modernScreen .staff-toolbarSearch {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 620px) {\n  .staff-modernScreen .staff-toolbarSearch {\n    grid-template-columns: 1fr;\n  }\n}\n.staffRoleModal.modal-dialog {\n  max-width: 560px !important;\n}\n.staffRoleModal .modal-content {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  overflow: hidden;\n}\n.staffRoleModal .modal-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: #fff;\n}\n.staffRoleModal .modal-title {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));\n  font-size: 18px;\n  font-weight: 800;\n}\n.staffRoleModal .modal-body {\n  padding: 18px 20px 20px !important;\n}\n.staffRoleModal form {\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.staffRoleModal form .form-control {\n  min-height: 40px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  box-shadow: none;\n}\n.staffRoleModal form .form-control:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n.staffRoleModal form label {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n}\n.staffRoleModal form .btn {\n  min-height: 40px;\n  padding: 0 15px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: none;\n}\n.staffRoleModal form .btn-primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n.staffRoleModal form .btn-secondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-dialog {\n  max-width: 560px;\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-content {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  overflow: hidden;\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: #fff;\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-title {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));\n  font-size: 18px;\n  font-weight: 800;\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-body {\n  padding: 18px 20px !important;\n  color: var(--text-body, #334155);\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-footer {\n  padding: 14px 20px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-footer .btn {\n  min-height: 40px;\n  padding: 0 15px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: none;\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-footer .btn-primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n.staffsPage > .modal:not(.userTagActionModal) .modal-footer .btn-secondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n}\n.staffsPage > .modal:not(.userTagActionModal) .form-control {\n  min-height: 40px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  box-shadow: none;\n}\n.staffsPage > .modal:not(.userTagActionModal) .form-control:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
